/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ResourcePoolRequestOperationType = 'ASSIGN' | 'UNASSIGN';

export const ResourcePoolRequestOperationType = {

    ASSIGN: 'ASSIGN' as ResourcePoolRequestOperationType,

    UNASSIGN: 'UNASSIGN' as ResourcePoolRequestOperationType
};

